import './polywizz-list.scss';
import { PolywizzProvider } from './context';
import { Card } from 'react-bootstrap';
import Filters from './filters';
import TotalInfo from './total-info';
import PolywizzPageHeader from './header';
import PolywizzTable from './table';

const InsurancePolywizzList = () => {
    return (
        <div className="polywizz-list">
            <PolywizzProvider>
                <PolywizzPageHeader />
                <Card dir="rtl">
                    <Card.Body>
                        <Filters />
                        <TotalInfo />
                        <PolywizzTable />
                    </Card.Body>
                </Card>
            </PolywizzProvider>
        </div>
    );
};

export default InsurancePolywizzList;
